(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("c-product-media")) {
  customElements.define(
    "c-product-media",
    class ComponentProductMedia extends HTMLElement {
      constructor() {
        super();
        this.curColor = "";
      }

      connectedCallback() {
        this.thumbsSwiper = new Swiper(".js-product-media__thumbs-swiper", {
          direction: "vertical",
          spaceBetween: 8,
          slidesPerView: "auto",
          watchSlidesProgress: true,
        });

        this.mainSwiper = new Swiper(".js-product-media__main-swiper", {
          spaceBetween: 8,
          slidesPerView: 1.2,
          thumbs: {
            swiper: this.thumbsSwiper,
          },
          breakpoints: {
            768: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
          },
        });

        this.fullscreenBtn = Array.from(
          this.querySelectorAll(".js-product-media__main-fullscreen")
        );

        this.fullscreenBtn.forEach((btn) => {
          btn.addEventListener("click", this.openFullscreen.bind(this, btn));
        });
      }

      openFullscreen = (btn) => {
        let slideIndex = btn.dataset.index;
        window.PubSub.publish("modal-media", slideIndex);
      };

      updateProductMedia = () => {
        if (!this.curColor) {
          this.curColor = document
            .querySelector(".c-variant-picker__name")
            ?.textContent.trim();
            document.querySelectorAll(".c-variant-picker__item").forEach((el) => {
              el.addEventListener("click", () => {
                this.curColor = el.textContent.trim();
              });
            });
        } else {
          document.querySelectorAll(".c-variant-picker__item").forEach((el) => {
            el.addEventListener("click", () => {
              this.curColor = el.textContent.trim();
            });
          });
        }
        if (!this.curColor) return;

        const thumbSlides = this.querySelectorAll(
          ".c-product-media__thumbs-slide"
        );

        thumbSlides.forEach((el, index) => {
          const img = el.querySelector("img");
          if (img && img.alt.trim() === this.curColor) {
            this.mainSwiper.slideTo(index);
          }
        });
        this.curColor = ''
      };
    }
  );
}

},{}]},{},[1])

